import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Sidebar from '../components/layout/Sidebar';
import Footer from '../components/layout/Footer';
import LatestSongsNotifications from '../components/common/LatestSongsNotifications';
import LatestPaymentsNotifications from '../components/common/LatestPaymentsNotifications';
import { canViewPaymentAdmin } from '../utils/authConfig';

const MainLayout = ({ children, auth }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
    return () => document.body.classList.remove('sidebar-open');
  }, [sidebarOpen]);

  useEffect(() => {
    if (!auth.isAuthenticated) {
      navigate('/login');
    }
  }, [auth.isAuthenticated, navigate]);

  if (!auth.isAuthenticated) {
    return null;
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="layout-wrapper">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <div className="layout-page">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="content-wrapper">
          <div className="container-xxl flex-grow-1 container-p-y">
            {children}
          </div>
          <Footer />
        </div>
      </div>
      <LatestSongsNotifications />
      {canViewPaymentAdmin() && <LatestPaymentsNotifications />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(MainLayout); 